import React from 'react'

const callout = <div className="doc-callout doc-callout-secondary">
  <span className="doc-callout-type-label"><i className="fas fa-exclamation-circle"/> Heads up</span>
  <strong>This is a recap of a question & answer from an Autodesk forum thread.</strong>
  <p className="p-push-down">
    We often answer .PAT file related questions on Autodesk forums. Sometimes people have similar questions and to ensure that content has a home in case the forum content is removed, we recap the important parts of the conversation in our docs.
  </p>
</div>

export default callout;


// WEBPACK FOOTER //
// ./src/docs/qa-callout.js